import { render, staticRenderFns } from "./MenuOptionsNavigation.vue?vue&type=template&id=492efb4c&scoped=true"
import script from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
export * from "./MenuOptionsNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuOptionsNavigation.vue?vue&type=style&index=0&id=492efb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492efb4c",
  null
  
)

export default component.exports